/* LUNA tabbed product rail — H4 / D22.
   Inactive panels ship as <template> and are cloned on first select, so only one tab's
   images ever enter the DOM (Bedrock ships 161 <img> in theirs). */
(function(){
  if(window.__lunaTabs) return; window.__lunaTabs = true;

  function initSection(root){
    var tablist = root.querySelector('[role="tablist"]');
    if(!tablist || tablist.__luna) return; tablist.__luna = true;
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    var viewAll = root.querySelector('[data-luna-viewall]');

    function panelOf(i){ return root.querySelector('#' + tabs[i].getAttribute('aria-controls')); }

    function hydrate(panel){
      var tpl = panel.querySelector('template[data-luna-panel]');
      if(tpl){ panel.appendChild(tpl.content.cloneNode(true)); tpl.remove(); }
      if(window.lunaCardScan) window.lunaCardScan(panel);
      if(window.lunaReveal) window.lunaReveal(panel);
      wireRail(panel);
    }

    function wireRail(panel){
      var rail = panel.querySelector('[data-luna-rail]');
      if(!rail || rail.__wired) return; rail.__wired = true;
      var prev = panel.querySelector('[data-luna-prev]'), next = panel.querySelector('[data-luna-next]');
      var count = rail.children.length;
      // shallow tabs render as a left-aligned grid, not a carousel with dead space
      if(count <= 3){
        rail.classList.add('is-shallow');
        rail.style.setProperty('--luna-n', count);
        if(prev) prev.hidden = true; if(next) next.hidden = true;
        return;
      }
      function upd(){
        var max = rail.scrollWidth - rail.clientWidth - 2;
        if(prev){ prev.hidden = max <= 0; prev.disabled = rail.scrollLeft <= 1; }
        if(next){ next.hidden = max <= 0; next.disabled = rail.scrollLeft >= max; }
      }
      if(prev) prev.addEventListener('click', function(){ rail.scrollBy({left:-rail.clientWidth*0.7, behavior:'smooth'}); });
      if(next) next.addEventListener('click', function(){ rail.scrollBy({left: rail.clientWidth*0.7, behavior:'smooth'}); });
      rail.addEventListener('scroll', upd);
      requestAnimationFrame(upd); setTimeout(upd, 300);
    }

    function select(i){
      tabs.forEach(function(t,n){
        var p = panelOf(n);
        t.setAttribute('aria-selected', String(n===i));
        t.tabIndex = n===i ? 0 : -1;
        if(p) p.hidden = n!==i;
      });
      var panel = panelOf(i);
      if(panel) hydrate(panel);
      if(viewAll && tabs[i].dataset.url){
        viewAll.href = tabs[i].dataset.url;
        viewAll.setAttribute('aria-label', 'View all ' + tabs[i].textContent.trim());
      }
    }

    tabs.forEach(function(t,i){ t.addEventListener('click', function(){ select(i); }); });
    tablist.addEventListener('keydown', function(e){
      var cur = tabs.findIndex(function(t){ return t.getAttribute('aria-selected') === 'true'; });
      var n = null;
      if(e.key === 'ArrowRight') n = (cur+1) % tabs.length;
      if(e.key === 'ArrowLeft')  n = (cur-1+tabs.length) % tabs.length;
      if(e.key === 'Home') n = 0;
      if(e.key === 'End')  n = tabs.length-1;
      if(n === null) return;
      e.preventDefault(); select(n); tabs[n].focus();
    });

    select(0);
  }

  function scan(root){ (root||document).querySelectorAll('[data-luna-tabs]').forEach(initSection); }
  document.addEventListener('DOMContentLoaded', function(){ scan(document); });
  if(document.readyState !== 'loading') scan(document);
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
})();